export const EDIT_TEMPLATE_MODAL = 'EDIT_TEMPLATE_MODAL';
export const EDIT_NOTES_MODAL = 'EDIT_NOTES_MODAL';
export const EDIT_NAME_MODAL = 'EDIT_NAME_MODAL';

export const setEditTemplateModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_TEMPLATE_MODAL, state });
};

export const setEditNotesModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_NOTES_MODAL, state });
};

export const setEditNameModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_NAME_MODAL, state });
};

export default {
    EDIT_TEMPLATE_MODAL,
    EDIT_NOTES_MODAL,
    EDIT_NAME_MODAL,
    setEditTemplateModal,
    setEditNotesModal,
    setEditNameModal,
};
